/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// STRUCTURE : FOOTER : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	footer: {
		// background: theme.color.supporting.light.swatch,
		background: `linear-gradient(to bottom, ${theme.color.supporting.light.swatch} 0%,#ffffff 100%)`,
		borderTop: replacePXinStringWithEM(`1px solid ${theme.color.grey.medium.swatch}`),
		// boxShadow: replacePXinStringWithEM(`0 -1px 0 0 ${theme.boxShadow.bar}`),
		color: theme.color.dark.dark.contrast,
		height: pxToEm(103),
		width: '100%',
		padding: replacePXinStringWithEM(`0px ${theme.spacing.sides}`),
		position: 'relative',

		// layout
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'space-between',
		alignContent: 'center',
		alignItems: 'center',

		// animations
		opacity: '0',
		animationName: 'fadeInUp',
		animationDelay: '.1s',
		animationDuration: '.2s',
		animationFillMode: 'forwards',

		// ----- groups ----- //
		'& .name-info': {
			color: '#A4A4AD',
			textAlign: 'left'
		},
		'& .name-links': {
			color: theme.color.supporting.dark.swatch,
			'& a': {
				color: theme.color.supporting.dark.swatch
			}
		}
	}
});